import { REQUEST, SUCCESS, FAILURE } from '../../actions/auth/updateProfile';

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  user: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        user: action.payload.user,
        error: null
      };
    case FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
